import { render, staticRenderFns } from "./ErrorPage.vue?vue&type=template&id=4a71f86d&scoped=true"
import script from "./ErrorPage.vue?vue&type=script&lang=js"
export * from "./ErrorPage.vue?vue&type=script&lang=js"
import style0 from "./ErrorPage.vue?vue&type=style&index=0&id=4a71f86d&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a71f86d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/actions-runner/_work/treasurenet-tnservices-airdrop-fe/treasurenet-tnservices-airdrop-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4a71f86d')) {
      api.createRecord('4a71f86d', component.options)
    } else {
      api.reload('4a71f86d', component.options)
    }
    module.hot.accept("./ErrorPage.vue?vue&type=template&id=4a71f86d&scoped=true", function () {
      api.rerender('4a71f86d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ErrorPage.vue"
export default component.exports